export const SEND_PRAYS = 'SEND_PRAYS';
export const SET_USER = 'SET_USER';
export const SET_ANALYTICS = 'SET_ANALYTICS';